document.addEventListener('DOMContentLoaded', function () {
    const calcContainers = document.querySelectorAll('.calc-form-container');
    if (!calcContainers.length) return;

    calcContainers.forEach((calcContainer) => {
        const wrapper = calcContainer.closest('.calculator-wrapper') || calcContainer;

        const calcType = parseInt(calcContainer.dataset.calcType, 10);
        const unit = parseFloat(calcContainer.dataset.unitFactor); // PerKG value
        const idPrefix = calcContainer.dataset.idPrefix || '';

        const resultElements = wrapper.querySelectorAll('.calc-result-value');
        const inputs = wrapper.querySelectorAll('.calc-trigger');

        inputs.forEach((input) => {
            input.addEventListener('input', calculate);
            input.addEventListener('change', calculate);
        });

        // Initial calculation (handles prefilled fields)
        calculate();

        function calculate() {
            if (!unit || isNaN(unit)) {
                updateResults(0);
                return;
            }

            switch (calcType) {
                case 1:
                    calculateAreaDepth();
                    break;
                case 2:
                    calculateFrame();
                    break;
                case 3:
                    calculateLinearMetre();
                    break;
                case 5:
                    calculateArea();
                    break;
                case 6:
                    calculateSlab();
                    break;
                case 7:
                    calculateLinearJoint();
                    break;
                case 8:
                    calculateTile();
                    break;
                default:
                    updateResults(0);
            }
        }

        function updateResults(totalKilosRequired) {
            resultElements.forEach((el) => {
                const boxSize = parseFloat(el.dataset.packSize);

                if (boxSize > 0 && totalKilosRequired > 0) {
                    const packsNeeded = Math.ceil(totalKilosRequired / boxSize);
                    el.innerText = packsNeeded;
                } else {
                    el.innerText = '0';
                }
            });
        }

        function safeEscape(value) {
            if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
            return value.replace(/[^a-zA-Z0-9_-]/g, '\\$&');
        }

        function val(id) {
            const fullId = `${idPrefix}${id}`;
            const el = wrapper.querySelector(`#${safeEscape(fullId)}`);
            return el ? parseFloat(el.value) || 0 : 0;
        }

        // --- FORMULAS (ported from legacy frontend.js) ---

        function calculateAreaDepth() {
            const area = val('area-type-1');
            const depth = val('depth-type-1');

            const physicalArea = area * (depth / 1000);
            const req = physicalArea / unit;
            updateResults(req);
        }

        function calculateFrame() {
            const frameWidth = val('frame-width-type-2');
            const frameLength = val('frame-length-type-2');
            const flangeWidth = val('flange-width-type-2');
            const mortarDepth = val('mortar-depth-type-2');

            const area = (2 * (frameWidth * flangeWidth)) + (2 * ((frameLength - flangeWidth - flangeWidth) * flangeWidth));
            const volume = ((area / 1000000) * (mortarDepth / 1000)) * 4.5;
            const req = volume / unit;
            updateResults(req);
        }

        function calculateLinearMetre() {
            const metres = val('metres-type-3');
            const req = metres / unit;
            updateResults(req);
        }

        function calculateArea() {
            const metres = val('metres-type-5');
            const req = metres / unit;
            updateResults(req);
        }

        function calculateSlab() {
            const area = val('area-type-6');
            const slabWidth = val('slab-width-type-6');
            const slabLength = val('slab-length-type-6');
            const jointWidth = val('joint-width-type-6');
            const jointDepth = val('joint-depth-type-6');

            const slabArea = ((slabWidth + jointWidth) / 1000) * ((slabLength + jointWidth) / 1000);

            if (slabArea > 0) {
                const slabsRequired = area / slabArea;
                const jointVolume = ((slabWidth + slabLength) / 1000) * ((jointWidth * jointDepth) / 1000) * slabsRequired;
                const req = jointVolume / unit;
                updateResults(req);
            } else {
                updateResults(0);
            }
        }

        function calculateLinearJoint() {
            const metres = val('metre-type-7');
            const jointWidth = val('joint-width-type-7');
            const jointDepth = val('joint-depth-type-7');

            const req = (((jointWidth * jointDepth) / 1000) * metres) / unit;
            updateResults(req);
        }

        function calculateTile() {
            const area = val('area-type-8');
            const tileWidth = val('tile-width-type-8');
            const tileLength = val('tile-length-type-8');
            const jointWidth = val('joint-width-type-8');
            const jointDepth = val('joint-depth-type-8');

            const tileDimensions = tileWidth + tileLength;
            const jointDimensions = jointWidth * jointDepth;
            const tileArea = tileLength * tileWidth;

            if (tileArea > 0) {
                // Type 8 multiplies unit (legacy behavior)
                const req = (((tileDimensions * jointDimensions) * unit) / tileArea) * area;
                updateResults(req);
            } else {
                updateResults(0);
            }
        }
    });
});